import axios from 'axios';

export async function getScorerLeagueTable(league_pk) {


  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/leaderboards/league/${league_pk}/league_leaderboard/scorers/`,

    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

